<template>
  <div class="row">
    <div class="col-md-9">
      <div class="card card-default">
        <service-wizard-layout
          title=""
          subtitle=""
          :parts="parts"
          :onComplete="onComplete"
          :validateStep="validateStep"
        >
          <template slot="domain">
            <form novalidate data-vv-scope="domain">
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div
                    class="form-group"
                    :class="{
                      'has-error': errors.has('domain.name'),
                    }"
                  >
                    <label>Domain Name:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-validate="'required'"
                      name="name"
                      v-model="filledInSaleDefinition.requiredObjs.domain.name"
                    />
                    <span class="has-error" v-if="errors.has('domain.name')">{{
                      errors.first("domain.name")
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div
                    class="form-group"
                    :class="{
                      'has-error': errors.has('domain.ttl'),
                    }"
                  >
                    <label>Minimum TTL:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-validate="'required'"
                      name="ttl"
                      v-model="filledInSaleDefinition.requiredObjs.domain.minimumTtl"
                    />
                    <span class="has-error" v-if="errors.has('domain.ttl')">{{
                      errors.first("domain.ttl")
                    }}</span>
                  </div>
                </div>
              </div>
              
            </form>
          </template>
        </service-wizard-layout>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import ServiceWizardLayout from "@/layouts/ServiceWizardLayout";

export default {
  components: {
    ServiceWizardLayout,
  },
  props: {
    emptySaleDefinition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      parts: [
        {
          name: "domain",
          displayName: "Domain",
          icon: "fa fa-cloud",
        },
      ],
      filledInSaleDefinition: {
        requiredObjs: {
            domain: {}
        },
        selectableOptions: {

        }
      },
    };
  },
  mounted() {
    this.filledInSaleDefinition = this.emptySaleDefinition;
  },
  methods: {
    onComplete() {
      this.$emit("createSale", this.filledInSaleDefinition);
    },
    validateStep(scope) {
      return this.$validator.validateAll(scope).then((result) => {
        if (result) {
          return true;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
</style>